var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    { 'border-coolrunner-500': _vm.selected },
    'border rounded-md hover:shadow-md cursor-pointer flex flex-col mb-5 items-center p-5 transition duration-300 ease-in-out'
  ],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }